import { createSlice } from '@reduxjs/toolkit'

export const saleTypeSlice = createSlice({
  name: 'saleType',
  initialState: {
    isPublicSale: false,
  },
  reducers: {
    setPublicSale: (state) => {
        state.isPublicSale = true;
    },
    setPrivateSale: (state) => {
        state.isPublicSale = false;
    },
  },
})

export const { setPrivateSale, setPublicSale } = saleTypeSlice.actions

export const selectIsPublicSale = (state) => state.saleType.isPublicSale

export default saleTypeSlice.reducer